// src/shared/utils/showToastHelper.tsx
import React from "react";
import { useToast } from "../../../../../shared/hooks";
import { ToastContent } from "../../../../../shared/components";

export type ToastType = "error" | "success" | "info";

/**
 * Exibe um toast padronizado no topo da tela.
 * @param toastHandler Instância retornada por useToast()
 * @param message Mensagem a ser exibida
 * @param type Tipo de toast (error | success | info)
 * @param title Título opcional (default: "Alerta!")
 */
export const showToastHelper = (toastHandler: ReturnType<typeof useToast>, message: string, type: ToastType, title: string = "Alerta!") => {
	toastHandler.present({
		type,
		position: "top-right",
		messageOrContent: <ToastContent title={title} content={message} />,
	});
};
